module.exports = __webpack_public_path__ + "img/DiCross.7425c6e4.jpg";